import { Button, Grid, Heading, Layout } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { UploadIcon } from '@enterprise-ui/icons'
import { useUploadHistory } from './useUploadHistory'
import { useUploadMfe } from './useUploadMfe'

export const UploadHistoryMfe = ({ ...rest }) => {
  const { handleUploadClick, uploadModal, historyRefreshKey, mfeReloadKey } =
    useUploadMfe()
  // Upload modal and history MFE must share the same keys for post-upload refresh.
  const { uploadHistoryMfe } = useUploadHistory({
    ...rest,
    historyRefreshKey,
    mfeReloadKey,
  })

  return (
    <Layout.Body
      data-testid="upload-history-page"
      includeRail
      className="layout-body-section"
      style={{ marginTop: 55, paddingTop: 0 }}
    >
      {uploadModal}
      <Grid.Container
        justify="space-between"
        className="hc-pv-md hc-bg-contrast-weak"
      >
        <Grid.Item>
          <Heading>Upload History</Heading>
          <div className="hc-clr-grey01">
            Track all your bulk upload requests. In case of rejections, download
            the rejected items, rectify errors, and re-upload the file.
          </div>
        </Grid.Item>
        <Grid.Item>
          <Button type="secondary" onClick={() => handleUploadClick()}>
            <EnterpriseIcon icon={UploadIcon} size="md" />
            Upload item data
          </Button>
        </Grid.Item>
      </Grid.Container>
      {uploadHistoryMfe}
    </Layout.Body>
  )
}
